import React, { useEffect, useState } from 'react';
import { Row, Button, Modal, Col } from 'antd';
import { FormProps } from '../../utility/types';
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from '../../services/toast.notification';
import { ColumnsType } from 'antd/lib/table';
import { getDeliveryType, getLabInstallerItemDetails, getLabInstallerItems, labInstallationItemsApproveUser, labInstallationTypeApproveUser } from '../../api/api';
import Spinner from '../../components/_common/Spinner';
import { useAppSelector } from '../../redux/store/storehooks';
import { confirmAlert } from 'react-confirm-alert';


export const SendCabledialog: React.FC<FormProps>
    = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {

        const [deliveryInstallList, setDeliveryInstallList] = useState<any[]>([]);
        const [sendCablePayload, setSendCableDialogPayload] = useState({ cableRequestId: 0, machineInstallRequestId: 0, labId: 0 });
        const [showSendCableDialog, setshowDelivaryItemDialog] = useState(false);
        const [selectedLab, setSelectedLab] = useState("0");
        const [isLoading, setIsLoading] = useState(false);
        const [labInstallationItems, setLabInstallationItems] = useState([]);
        const [labInstallationItemDetails, setLabInstallationItemDetails] = useState([]);
        const myStore = useAppSelector((state) => state)

        const columns: ColumnsType<any> = [
            {
                title: 'عملیات', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                    <Button type="primary" style={{ backgroundColor: "green" }} onClick={() =>
                        SendItem(record.prk_DeliveryType_AutoID)}>   آیتم ها</Button>
                )
            },
            { title: ' تعداد آیتم ها', dataIndex: 'int_CountItem', key: 'int_CountItem' },
            { title: 'تعداد انجام شده', dataIndex: 'int_CountDoItem', key: 'int_CountDoItem' },
            { title: ' تعداد تایید شده', dataIndex: 'int_CountLabApprove', key: 'int_CountLabApprove' },
            { title: 'نوع تحویل', dataIndex: 'str_DeliveryType', key: 'str_DeliveryType' },


        ];

        const SendItem = (id: number) => {

            setshowDelivaryItemDialog(true);


            setSendCableDialogPayload((values: any) => ({

                ...values,
                typeId: id,
                labId: payLoad.labId,
                // deliveyType:values.prk_DeliveryType_AutoID
                // cableRequestId: id,
                // machineInstallRequestId:machineInstallRequestId,
                // labId:labId
            }));

        }
        useEffect(() => {

        }, [])

        const _getLabInstallerItemDetails = (typeId: number) => {
            setIsLoading(true);

            getLabInstallerItemDetails(typeId)
                .then((result: any) => {
                    setLabInstallationItemDetails(result.data.data);
                    setIsLoading(false);
                })
                .catch((error: any) => {
                    console.log(error);
                    setIsLoading(false);

                    errorNotifyByErrorObject(error, undefined, 5000)
                })
        }

        const loadInstallerItems = (labId:number,userId:number) => {

            getLabInstallerItems(userId,labId)
                .then((result: any) => {
                    setSendCableDialogPayload((values: any) => ({
                        ...values,
                        installItems:result.data.data
                    }));
                    payLoad.installItems = result.data.data
                    //setLabInstallationItems(result.data.data);
                })
                .catch((error: any) => {
                    console.log(error);
                    errorNotifyByErrorObject(error, undefined, 5000)
                })
    
            // getLabInstallationItems()
            //     .then((result: any) => {
            //         setLabInstallationItems(result.data.data);
            //     })
            //     .catch((error: any) => {
            //         console.log(error);
            //         errorNotifyByErrorObject(error, undefined, 5000)
            //     })
    
        }

        const _approveItem = (itemId: number,itemType:number) => {
            labInstallationItemsApproveUser(itemId, Number(myStore.auth.userId), Number(myStore.auth.userId), 0, payLoad.labId, "")
                .then((result: any) => {
                    sucessNotify("اطلاعات با موفقیت ثبت شد", undefined, 5000)
                    setIsLoading(false);
                    _getLabInstallerItemDetails(itemType);
                })
                .catch((error: any) => {
                    console.log(error);
                    setIsLoading(false);
                    errorNotifyByErrorObject(error, undefined, 5000)
                })
        }

        const _approveType = (id: number) => {
            var approveFlag = true;
            const arr :any = [];

            getLabInstallerItemDetails(id)
                .then((result: any) => {
                    var items = result.data.data;
                    items.map((item: any) => {
                        if (item.bit_done == 0) {
                            confirmAlert({
                                title: "",
                                message: "آیتم های چک لیست انجام نشده آیا می خواهید همگی را انجام دهید؟",
                                buttons: [
                                    {
                                        label: "خیر",
                                        onClick: () => {
                                            approveFlag = false;
                                        }

                                    },
                                    {
                                        label: "بله",
                                        onClick: () => {
                                            items.map((item: any) => {
                                                if (item.bit_done == 0) {
                                                arr.push(_approveItem(item.prk_DeliveyItemVUser,id));
                                                }
                                            })
                                            approveFlag = true;
                                        }
                                    }
                                ]
                            });
                        }
                    })
                })
                .catch((error: any) => {
                    console.log(error);
                    setIsLoading(false);

                    errorNotifyByErrorObject(error, undefined, 5000)
                })


            
                Promise.all(arr).then((responses) => {
                    debugger;
                labInstallationTypeApproveUser(id, 0, Number(myStore.auth.userId), 0, payLoad.labId, "")
                    .then((result: any) => {
                        sucessNotify("اطلاعات با موفقیت ثبت شد", undefined, 5000)
                        setIsLoading(false);
                        loadInstallerItems(payLoad.labId,Number(myStore.auth.userId));
                    })
                    .catch((error: any) => {
                        console.log(error);
                        setIsLoading(false);
                        errorNotifyByErrorObject(error, undefined, 5000)
                    })
            });

        }

        return (

            <Modal
                width={1100}
                visible={visible}
                onCancel={onCancel}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <>
                    <Row className='header'>
                        <Col lg={6} md={6} sm={24} xs={24}>
                            عنوان
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                            تاریخ ایجاد
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                            وضعیت
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                            تاریخ انجام
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                            وضعیت تایید
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                            تاریخ تایید
                        </Col>
                        <Col lg={6} md={6} sm={24} xs={24}>
                            توضیحات
                        </Col>
                        <Col lg={2} md={2} sm={24} xs={24}>
                            عملیات
                        </Col>
                    </Row>
                    <Row>
                        <div className="container" >
                            <div className="accordion" id="accordionExample">
                                {payLoad.installItems !== undefined && payLoad.installItems.length > 0 &&
                                    payLoad.installItems.map((itemType: any, index: number) => {
                                        let dataBsTarget = "#collapse" + index.toString();
                                        let ariaControls = "collapse" + index.toString();

                                        return (
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" style={{ display: "flex", fontSize: "14px" }}>
                                                    <Col lg={6} md={6} sm={24} xs={24}>
                                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={dataBsTarget} aria-expanded="false" aria-controls={ariaControls}
                                                            onClick={() => _getLabInstallerItemDetails(itemType.prk_DeliveyTypeVUser)}>
                                                            {itemType.str_DeliveryType}
                                                        </button>
                                                    </Col>
                                                    <Col lg={2} md={2} sm={24} xs={24}>
                                                        {itemType.creationDate}
                                                    </Col>
                                                    <Col lg={2} md={2} sm={24} xs={24}>
                                                        {itemType.str_done}
                                                    </Col>
                                                    <Col lg={2} md={2} sm={24} xs={24}>
                                                        {itemType.doDate}
                                                    </Col>
                                                    <Col lg={2} md={2} sm={24} xs={24}>
                                                        {itemType.approveLab}
                                                    </Col>
                                                    <Col lg={2} md={2} sm={24} xs={24}>
                                                        {itemType.approveDate}
                                                    </Col>
                                                    <Col lg={6} md={6} sm={24} xs={24}>
                                                        {itemType.str_Description}
                                                    </Col>

                                                    <Col lg={2} md={2} sm={24} xs={24}>
                                                        <Button disabled={itemType.bit_done} type="primary" style={{ backgroundColor: "green" }} onClick={() => _approveType(itemType.prk_DeliveyTypeVUser)} > انجام شد</Button>
                                                    </Col>
                                                </h2>


                                                <div id={ariaControls} className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        {!isLoading && labInstallationItemDetails !== undefined && labInstallationItemDetails.length > 0 &&
                                                            <Row className='inner-header'>
                                                                <Col lg={5} md={5} sm={24} xs={24}>
                                                                    عنوان
                                                                </Col>
                                                                
                                                                <Col lg={2} md={2} sm={24} xs={24}>
                                                                    وضعیت
                                                                </Col>
                                                                <Col lg={3} md={3} sm={24} xs={24}>
                                                                    تاریخ انجام
                                                                </Col>
                                                                <Col lg={2} md={2} sm={24} xs={24}>
                                                                    وضعیت تایید
                                                                </Col>
                                                                <Col lg={3} md={3} sm={24} xs={24}>
                                                                    تاریخ تایید
                                                                </Col>
                                                                <Col lg={6} md={6} sm={24} xs={24}>
                                                                    توضیحات
                                                                </Col>
                                                                <Col lg={3} md={3} sm={24} xs={24}>
                                                                    عملیات
                                                                </Col>
                                                            </Row>
                                                        }
                                                        {!isLoading && labInstallationItemDetails !== undefined && labInstallationItemDetails.length > 0 &&
                                                            labInstallationItemDetails.map((item: any, index: number) => {
                                                                return (
                                                                    <div>

                                                                        <Row style={{ padding: "10px" }}>

                                                                            <Col lg={5} md={5} sm={24} xs={24}>
                                                                                {item.str_DeliveryItem}
                                                                            </Col>
                                                                           
                                                                            <Col lg={2} md={2} sm={24} xs={24}>
                                                                                {item.str_done}
                                                                            </Col>
                                                                            <Col lg={3} md={3} sm={24} xs={24}>
                                                                                {item.doDate}
                                                                            </Col>
                                                                            <Col lg={2} md={2} sm={24} xs={24}>
                                                                                {item.approveLab}
                                                                            </Col>
                                                                            <Col lg={3} md={3} sm={24} xs={24}>
                                                                                {item.approveDate}
                                                                            </Col>
                                                                            <Col lg={6} md={6} sm={24} xs={24}>
                                                                                {item.str_Description}
                                                                            </Col>

                                                                            <Col lg={3} md={3} sm={24} xs={24}>
                                                                                <Button disabled={item.bit_done} type="primary" style={{ backgroundColor: "rgb(0, 161, 240)" }} onClick={() => _approveItem(item.prk_DeliveyItemVUser,itemType.prk_DeliveyTypeVUser)}> راه اندازی</Button>
                                                                            </Col>
                                                                        </Row>

                                                                    </div>
                                                                )
                                                            })

                                                        }

                                                        {isLoading === true && (
                                                            <Spinner />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    )}

                                    
                            </div>
                        </div>
                    </Row>
                </>


                {/* <div>
                    {(() => {
                        if (showSendCableDialog) {
                            return <DeliveryItems
                                payLoad={sendCablePayload}
                                visible={showSendCableDialog}
                                onSubmit={() => console.log(true)}
                                onCancel={() => { setshowDelivaryItemDialog(false); loadDeliveryInstall() }}
                                setShowDialog={() => { setshowDelivaryItemDialog(false) }}
                            />
                        }
                    })()}
                </div> */}

            </Modal>


        )
    }
